<template>
  <div class="vue-container">
    <div :id="appName"></div>
  </div>
</template>

<script>
//import Vue from 'vue';
/* eslint-disable */

export default {
  name: 'VueContainer.vue',
  props: {
    vueApp: Object
  },
  data () {
      return {
          vi: null,
          appName: this.vueApp.name,
          build: this.vueApp.path + this.vueApp.name + '.js',
          index: this.vueApp.path + 'index.html',
          iframeSrc: ''
      }
  },
  methods: {
    createVueApp() {
      console.log('BUILD FILE: '+this.build);
      let buildScript = document.createElement('script');
      buildScript.setAttribute('src', this.build);
      document.head.appendChild(buildScript);
    }
  },
  mounted () {
    this.createVueApp();
  }
}
</script>

<style scoped>
</style>
